import { AuthRequestDto } from '../models/auth.dto';
import { AuthFormVm } from '../models/auth.vm';

export class AuthMapper {
  static mapFormVmToRequest(formVm: AuthFormVm): AuthRequestDto {
    return {
      usuario: formVm.user,
      clave: formVm.password,
    };
  }
}
